<template>
  <div>
    <v-card tile elevation="0">
      <v-card-text>
        <v-row>
          <v-col md="4" class="pr-0">
            <client-week-dots :userId="userId" show-arrows  :showCalendar="true" />
          </v-col>
          <v-col md="8" class="pl-0">
            <user-engagement :userId="userId" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <client-activity-summary :userId="userId" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import UserEngagement from "@/components/reporting/blocks/UserEngagement";
import ClientActivitySummary from "@/components/client/blocks/activity/ClientActivitySummary";
import ClientWeekDots from "@/components/client/blocks/progress/ClientWeekDots";

export default {
  name: "ClientActivity",
  components: {
    ClientActivitySummary,
    ClientWeekDots,
    UserEngagement,
  },
  props: ["userId"],
  data() {
    return {};
  },
};
</script>
